import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AccountLogo from 'components/Account-Logo';
import TasksFilter from '../../components/Tasks-Filter';
import GuidelinesFilter from '../../pages/guideline/components/Guidelines-Filter';
import TasksSummary from 'components/Tasks-Summary';

const KanbanHeader = ({ board, accountId, filterTotal, isContent, isGuideline, userStatus }) => {
  const [filterSide, setFilterSide] = useState(false);

  const filterTotalReturn = () => {
    return filterTotal;
  };

  return (
    <TaskSummmaryLayout className="task-summary-wrapper m-0 p-4">
      <div className="task-summary-photo">
        <AccountLogo accountId={accountId} />
      </div>

      {isGuideline ? (
        <GuidelinesFilter toggleFilter={setFilterSide} accountId={accountId} show={filterSide} />
      ) : (
        <TasksFilter toggleFilter={setFilterSide} accountId={accountId} show={filterSide} />
      )}

      <TasksSummary
        isContent={isContent}
        isGuideline={isGuideline}
        board={board}
        toggleFilter={setFilterSide}
        filterTotal={filterTotalReturn}
        userStatus={userStatus}
        show={!filterSide}
      />
    </TaskSummmaryLayout>
  );
};

const TaskSummmaryLayout = styled.div`
  .task-summary-logo {
    margin-left: 0 !important;
  }
`;

KanbanHeader.propTypes = {
  board: PropTypes.object,
  accountId: PropTypes.string,
  filterTotal: PropTypes.number,
  isContent: PropTypes.bool,
  isGuideline: PropTypes.bool,
  userStatus: PropTypes.string,
  t: PropTypes.func,
};

export default KanbanHeader;
